import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import type { TFunction } from "core/entities";

export function PublicEstimateRequestSubmitSuccess({ t }: { t: TFunction }) {
  return (
    <Alert
      severity="success"
      sx={{ width: "fit-content", marginInline: "auto", marginBlockStart: 4 }}
    >
      <AlertTitle>{t("estimateSubmitSuccessTitle")}</AlertTitle>
      {t("requestSubmittedMessage")}
    </Alert>
  );
}
